'use client';

import {
    Columns,
    ColumnsItem,
    Icon,
    IconName,
    IconSize,
    Price,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

type StickyItemProps = {
    iconName: IconName;
    offerType: string;
    noOfferLabel?: string;
    price?: number;
    order?: number;
    showCents?: boolean;
    titleBold?: boolean;
    promoLabel?: string;
    hideIcon?: boolean;
};

export default function StickyItem({
    iconName,
    offerType,
    noOfferLabel = 'Aucun forfait sélectionné',
    price,
    order,
    showCents = true,
    titleBold = true,
    promoLabel,
    hideIcon = false,
}: Readonly<StickyItemProps>) {
    return (
        <>
            <View className='icon-and-text is-hidden-mobile' style={{ order }}>
                <Icon
                    className={hideIcon ? 'is-invisible' : ''}
                    name={iconName}
                    size={IconSize.SMALLER}
                    circled
                    backgroundColor={TrilogyColor.SECONDARY20}
                />
                <View>
                    <Text level={TextLevels.TWO} marginless>
                        <Text
                            level={TextLevels.TWO}
                            markup={TextMarkup.SPAN}
                            marginless
                            typo={titleBold ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : TypographyBold.TEXT_WEIGHT_NORMAL}
                        >
                            {offerType}
                        </Text>

                        {' :  '}
                        {price ? (
                            <>
                                {promoLabel ? <span>{`(${promoLabel}) `}</span> : ''}
                                <Price
                                    showCents={showCents}
                                    inline
                                    amount={price}
                                    period='mois'
                                    className='normal-weight'
                                />
                            </>
                        ) : (
                            <Text markup={TextMarkup.SPAN} level={TextLevels.TWO} marginless>
                                {noOfferLabel}
                            </Text>
                        )}
                    </Text>{' '}
                </View>
            </View>

            <View className='is-hidden-tablet' style={{ order }}>
                <Columns mobile className='' gapless marginless>
                    <ColumnsItem narrow>
                        <Text
                            marginless
                            level={TextLevels.THREE}
                            typo={titleBold ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : TypographyBold.TEXT_WEIGHT_NORMAL}
                        >
                            {offerType}
                        </Text>
                    </ColumnsItem>
                    <ColumnsItem className='has-text-right is-paddingless'>
                        {price ? (
                            <Text level={TextLevels.THREE}>
                                {promoLabel ? <span>{`(${promoLabel}) `}</span> : ''}
                                <Price
                                    showCents={showCents}
                                    inline
                                    amount={price}
                                    period='mois'
                                    className='has-text-weight-semibold'
                                />
                            </Text>
                        ) : (
                            <Text marginless level={TextLevels.THREE}>
                                {noOfferLabel}
                            </Text>
                        )}
                    </ColumnsItem>
                </Columns>
            </View>
        </>
    );
}
